import React, { useState } from "react";

// form components
import { Formik } from "formik";
import {
	Button,
	Confirm,
	Divider,
	Form,
	Grid,
	Header,
	Segment,
} from "semantic-ui-react";

// customs
import RateAndQuantity from "./Inputs/RateAndQuantity";
import SupplierInput from "./Inputs/SupplierInput";
import SellReceiptTable from "../SellReceiptTable";
import InvoiceUpload from "./InvoiceUpload";

// utils
import Alerts from "utilities/Alerts";
import http from "utilities/http";

// validators
import productAddForSell from "validators/productAddForSell";
import purchaseSubmitValidator from "validators/purchaseSubmit";
import CategoryAndProductInput from "./Inputs/CategoryAndProductInput";

function Purchase() {
	const [purchaseData, setPurchaseData] = useState([]);

	// confirmation modal
	const [openConfirm, setOpenConfirm] = useState(false);
	const [openModal, setOpenModal] = useState(false);

	// track load
	const [loading, setLoading] = useState(false);

	const addPurchaseRecord = (values, handlers) => {
		// setPurchaseData([values, ...purchaseData]);
		const alreadyExistingRecord = purchaseData.find(
			(item) => item.productId.toString() === values.productId
		);

		if (alreadyExistingRecord) {
			const existingQuantity = parseFloat(alreadyExistingRecord.quantity);
			alreadyExistingRecord.quantity =
				parseFloat(values.quantity) + existingQuantity;
			alreadyExistingRecord.rate = values.rate;
			const otherRecord = purchaseData.filter(
				(item) => item.productId.toString() !== values.productId
			);
			setPurchaseData([alreadyExistingRecord, ...otherRecord]);
		} else setPurchaseData([values, ...purchaseData]);

		handlers.resetForm();
		handlers.setFieldValue("buyer", values.buyer);
		handlers.setFieldValue("invoiceNo", values.invoiceNo);
	};

	// confirm modal controller
	const attemptSubmit = () => setOpenConfirm(true);
	const closeConfirm = () => setOpenConfirm(false);

	const attemptInvoiceUpload = () => setOpenModal(true);
	const closeModal = () => setOpenModal(false);

	/**
	 * @todo batch send purchase request
	 *
	 * @param {object} values
	 * @param {object} handlers
	 */
	const finalSubmit = async (values, handlers) => {
		try {
			const { supplier, invoiceNo, paid } = values;
			const particulars = [];

			for (const sd of purchaseData) {
				particulars.push(
					http({
						method: "POST",
						url: "/stock/purchase",
						data: {
							supplier,
							invoiceNo,
							...sd,
							paid,
						},
					})
				);
			}

			closeModal();
			closeConfirm();

			await processRequest(particulars);

			handlers.resetForm();
			setPurchaseData([]);

			Alerts.success("Purchase record added successfully.");
		} catch (ex) {
			Alerts.httpException(ex);
		} finally {
			setLoading(false);
		}
	};
	const processRequest = (particulars) =>
		Promise.all([particulars])
			.then((responses) => {
				Promise.resolve(responses);
			})
			.catch((ex) => Promise.reject(ex));
	return (
		<Segment basic loading={loading}>
			<Formik
				initialValues={{
					category: "",
					productId: "",
					quantity: "",
					rate: "",
				}}
				onSubmit={addPurchaseRecord}
				validationSchema={productAddForSell}
			>
				{({ handleSubmit }) => (
					<>
						<Form onSubmit={handleSubmit}>
							<Header as="h2">Add Purchase Record</Header>
							<Segment>
								<CategoryAndProductInput />
								<RateAndQuantity />
								<Button primary type="submit">
									Add Record
								</Button>
							</Segment>
						</Form>
					</>
				)}
			</Formik>

			<Divider hidden />

			<Formik
				initialValues={{ supplier: "", invoiceNo: "", paid: false }}
				onSubmit={attemptInvoiceUpload}
				validationSchema={purchaseSubmitValidator}
			>
				{({
					values,
					errors,
					touched,
					handleChange,
					handleSubmit,
					isSubmitting,
					...rest
				}) => (
					<Form onSubmit={handleSubmit}>
						<Segment>
							<Grid
								columns={2}
								style={{
									marginBottom: "0px",
									marginTop: "0px",
								}}
							>
								<Grid.Column>
									<SupplierInput />
								</Grid.Column>
								<Grid.Column>
									<Form.Input
										fluid
										label="Invoice Number"
										placeholder="XXXXX-XXX"
										name="invoiceNo"
										value={values.invoiceNo}
										onChange={handleChange}
									/>
									<p style={{ color: "red" }}>
										{errors.invoiceNo &&
											touched.invoiceNo &&
											errors.invoiceNo}
									</p>
								</Grid.Column>
							</Grid>
							<SellReceiptTable
								{...{
									sData: purchaseData,
									setSData: setPurchaseData,
								}}
							/>
							<Segment
								textAlign="right"
								style={{ padding: 0 }}
								basic
							>
								<Button
									type="submit"
									disabled={!purchaseData?.length}
									content="Purchase"
									positive
								/>
							</Segment>
							<Confirm
								open={openConfirm}
								onCancel={closeConfirm}
								onConfirm={() =>
									finalSubmit(values, { ...rest })
								}
							/>
						</Segment>
						<InvoiceUpload
							open={openModal}
							closeModal={closeModal}
							proceed={attemptSubmit}
						/>
					</Form>
				)}
			</Formik>
		</Segment>
	);
}

export default Purchase;
